import React from "react";
// oxlint-disable-next-line no-restricted-imports -- Legacy migration debt — do not copy into new code.
import { Alert } from "@design-system/Alert/Alert";
import { HStack } from "@design-system/HStack/HStack";
import { LockIcon } from "@icons";

export const PersonalDataAlert: React.FC = () => (
    <Alert variant="cta" className="mb-5">
        <HStack justify="center" align="center" className="w-100">
            <LockIcon className="icon-color-current mr-2" />
            Kick does not store any account password information
        </HStack>
    </Alert>
);
